// get product data
const product = JSON.parse(document.querySelector(".productV7JSON").textContent);
let activeVariant = JSON.parse(document.querySelector(".variantV7JSON").textContent);

// parse secondary product if configured in schema
const secondaryProductEl = document.querySelector(".productV7SecondaryJSON");
const secondaryProduct = secondaryProductEl ? JSON.parse(secondaryProductEl.textContent) : null;
let activeSecondaryVariant = secondaryProduct ? secondaryProduct.variants[0] : null;
let ottomanMode = "none";

// match an option name against both spellings, this file is shared between the US and AU stores
function isColorOption(optionName) {
    const name = String(optionName).trim().toLowerCase();
    return name === "color" || name === "colour";
}

// find the color option position in a product's option list
function getColorOptionIndex(options) {
    return options.findIndex(optionName => isColorOption(optionName));
}

// sync ottoman and chair colors by index of option
let primaryColorOptionIndex = getColorOptionIndex(product.options);
let secondaryColorOptionIndex = -1;
if (secondaryProduct) {
    secondaryColorOptionIndex = getColorOptionIndex(secondaryProduct.options);
}

/**************
 Product Swiper
 **************/
    // setup product swiper
const productSwiper = new Swiper(document.querySelector(".productV7VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        zoom: {
            maxRatio: 2,
            toggle: false
        },
        navigation: {
            nextEl: '.productV7VisualSwiper .swiper-button-next',
            prevEl: '.productV7VisualSwiper .swiper-button-prev',
        },
        on: {
            realIndexChange: () => {
                // update the thumbnail active class
                document.querySelectorAll(".productV7VisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
                document.querySelectorAll(`.productV7VisualThumbsSlide[data-index="${productSwiper.realIndex + 1}"]`).forEach(el => el.classList.add("active"));

                // pause all videos
                document.querySelectorAll(".productV7VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

// play video on slide play click
document.querySelectorAll(".productV7VisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productV7VisualSwiperSlide").querySelector("video");

        // remove play button if it hasn't already been removed
        this.querySelector(".productV7VisualSwiperSlidePlay")?.remove();

        if (video) {
            // show controls
            video.controls = true;

            // play video
            video.play();
        }
    });
});

// custom single-click zoom
document.querySelectorAll('.swiper-zoom-container')?.forEach(slide => {
    slide.addEventListener("click", () => productSwiper.zoom.toggle());
})

// change slide on thumbnail click
document.querySelectorAll(".productV7VisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideToLoop(this.dataset.index - 1);
    });
});

// mobile thumbnail swiper
const thumbnailSwiper = new Swiper(document.querySelector(".productV7VisualThumbs .swiper"), {
    slidesPerView: 'auto',
    // loop: true,
    navigation: {
        nextEl: '.productV7VisualThumbs .swiper-button-next',
        prevEl: '.productV7VisualThumbs .swiper-button-prev',
    },
});

// mobile active add
document.querySelectorAll(".productV7VisualThumbsSlide.swiper-slide").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('.productV7VisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
        this.classList.add('active');
    });
});

/**************
 Secondary Product
 **************/

// calculate total price based on ottoman mode
function getTotalPrice() {
    let totalPrice = 0;
    if (ottomanMode === "only" && activeSecondaryVariant) {
        totalPrice = activeSecondaryVariant.price;
    } else if (ottomanMode === "with" && activeSecondaryVariant) {
        totalPrice = activeVariant.price + activeSecondaryVariant.price;
    } else {
        totalPrice = activeVariant.price;
    }
    // check for global sale
    if (document.querySelector('.productGlobalSales')) {
        const salePrice = price(totalPrice - ((Number(document.querySelector('.productGlobalSales').dataset.globalSalePercentage) * totalPrice) / 100));
        document.querySelectorAll('.productGlobalSales').forEach(el => el.textContent = salePrice);
    }
    return totalPrice;
}

// calculate bottom bar total price based on ottoman mode
function getBottomTotalPrice() {
    let totalPrice = 0;
    if (ottomanMode === "only" && activeSecondaryVariant) {
        totalPrice = activeSecondaryVariant.price;
    } else if (ottomanMode === "with" && activeSecondaryVariant) {
        totalPrice = bottomVariant.price + activeSecondaryVariant.price;
    } else {
        totalPrice = bottomVariant.price;
    }
    // check for global sale
    if (document.querySelector('.productGlobalSales')) {
        totalPrice = totalPrice - ((Number(document.querySelector('.productGlobalSales').dataset.globalSalePercentage) * totalPrice) / 100);
    }
    return totalPrice;
}

function updateModeDisplay() {

    // update price to reflect selection
    document.querySelector(".productV7PriceReal").textContent = price(getTotalPrice());

    // keep hidden variant inputs in sync
    const formVariantInput = document.querySelector('.productV7FormVariant');
    const bottomVariantInput = document.querySelector('.productV7BottomVariant');
    if (ottomanMode === "only" && activeSecondaryVariant) {
        if (formVariantInput) formVariantInput.value = activeSecondaryVariant.id;
        if (bottomVariantInput) bottomVariantInput.value = activeSecondaryVariant.id;
    } else if (activeVariant) {
        if (formVariantInput) formVariantInput.value = activeVariant.id;
        if (bottomVariantInput) bottomVariantInput.value = activeVariant.id;
    }
}

// find secondary variant by matching user-selected options and auto-deriving color from primary
function updateSecondaryVariant() {
    if (!secondaryProduct) {
        return;
    }

    // build options array in secondary product option order
    const options = secondaryProduct.options.map(optionName => {
        // if no secondary, only return the main variant
        if (isColorOption(optionName) && primaryColorOptionIndex !== -1) {
            return activeVariant.options[primaryColorOptionIndex];
        }
        const input = document.querySelector(`.productV7SecondaryOptionsItem[data-value="${optionName}"] .productV7SecondaryOptionsItemValuesLabelInput:checked`);
        return input ? input.value : null;
    });

    if (options.every(o => o !== null)) {
        activeSecondaryVariant = secondaryProduct.variants.find(variant => {
            return JSON.stringify(variant.options) === JSON.stringify(options);
        });
    }

    updateModeDisplay();
}

// listen for ottoman mode radio changes
document.querySelectorAll(".productV7SecondaryModeValuesLabelInput").forEach(function (el) {
    el.addEventListener("change", function () {
        ottomanMode = this.value;

        // sync bottom mode select
        const bottomModeSelect = document.querySelector(".productV7BottomSecondaryMode");
        if (bottomModeSelect) {
            bottomModeSelect.value = ottomanMode;
        }

        preOrderUpdate()
        updateModeDisplay();
        updateBottomPrice();
    });
});

// listen for secondary option changes
document.querySelectorAll(".productV7SecondaryOptionsItemValuesLabelInput").forEach(function (el) {
    el.addEventListener("change", function () {
        // sync to the matching bottom secondary option select
        const optionName = this.closest(".productV7SecondaryOptionsItem").dataset.value;
        const bottomSelect = document.querySelector(`.productV7BottomSecondaryOptionItem[data-option="${optionName}"]`);
        if (bottomSelect) {
            bottomSelect.value = this.value;
        }

        updateSecondaryVariant();
        updateBottomPrice();
    });
});

// set initial secondary variant based on the primary product's active color on page load
if (secondaryProduct && secondaryColorOptionIndex !== -1) {
    updateSecondaryVariant();
}

/**************
 Product Variants
 ***************/

    // variable for the product form element
const productFormATC = document.querySelector(".productV7FormATC");

// update active variant on input changes
document.querySelectorAll(".productV7OptionItemValuesLabel").forEach(function (element) {
    element.addEventListener("change", function () {

        //update bottom ATC to match top
        const value = element.querySelector('input').value;
        const name = element.querySelector('input').name;
        document.querySelector(`.productV7BottomRight select[name="${name}"]`).value = value;

        updateBottomVariant();
        updateProduct().catch(e => console.error(e));
    });
})

// update active variant
async function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV7OptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    if (options.length !== 0) {
        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        productFormATC.classList.add("disabled");
        productFormATC.textContent = "Not Available";
        return;
    }

    // sync ottoman color to match the newly selected primary color
    if (secondaryColorOptionIndex !== -1) {
        updateSecondaryVariant();
    }

    // update variant (skip in ottoman-only mode — hidden input belongs to the ottoman there)
    if (ottomanMode !== "only") {
        document.querySelector('.productV7FormVariant').value = activeVariant.id;
    }

    // update intelligems id
    document.querySelectorAll('.productV7PriceReal, .productV7PriceCompare, .productV7PriceSavings').forEach(el => {
        el.setAttribute('data-variant-id', activeVariant.id);
    });

    // update price (factor in ottoman mode for combined/individual total)
    document.querySelector(".productV7PriceReal").textContent = price(getTotalPrice());
    if (ottomanMode === "none" && activeVariant.compare_at_price > activeVariant.price) {
        // a global sale styles the price as struck through instead
        document.querySelector(".productV7PriceReal").classList.toggle("sale", !document.querySelector('.productGlobalSales'));
        document.querySelector(".productV7PriceCompare").textContent = price(activeVariant.compare_at_price);
        document.querySelector(".productV7PriceSavings").textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`;
    } else {
        document.querySelector(".productV7PriceReal").classList.remove("sale");
        document.querySelector(".productV7PriceCompare").textContent = "";
        document.querySelector(".productV7PriceSavings").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        productFormATC.classList.remove("disabled");
        productFormATC.textContent = "Add To Cart";
    } else {
        productFormATC.classList.add("disabled");
        productFormATC.textContent = "Sold Out";
    }

    // update pre-order message
    preOrderUpdate()

    try {
        // update afterpay variant
        afterpay_current_variant = activeVariant;

        // update display price
        const afterpayElement = document.querySelector('[data-mpid="muscle-mat.myshopify.com"]');
        if (afterpayElement) afterpayElement.dataset.amount = activeVariant.price / 100;
    } catch (e) {
        console.error("Error updating afterpay pricing")
    }

    // slide to the variant's featured image if available
    if (activeVariant.featured_image) {
        productSwiper.slideToLoop(activeVariant.featured_image.position - 1);
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// update pre-order message
function preOrderUpdate() {
    // check the for both variants
    const addMessage = preOrder[activeVariant.id]?.message && ottomanMode !== "only";
    document.querySelector('.productV7PreOrderMessage').textContent = addMessage ? preOrder[activeVariant.id].message : "";
    // second message variable
    let addMessageSecondary = false;
    if (activeSecondaryVariant) {
        addMessageSecondary = preOrder[activeSecondaryVariant.id]?.message && ottomanMode !== "none";
        // the chair and the ottoman usually ship on the same date, only print it once
        if (addMessage && addMessageSecondary && preOrder[activeVariant.id].message === preOrder[activeSecondaryVariant.id].message) {
            addMessageSecondary = false;
        }
        document.querySelector('.productV7PreOrderSecondary').textContent = addMessageSecondary ? preOrder[activeSecondaryVariant.id].message : "";
    }
    if (addMessage || addMessageSecondary) {
        document.querySelector('.productV7PreOrder').classList.add('active');
    } else {
        document.querySelector('.productV7PreOrder').classList.remove('active');
    }

    // match the relax mat wording when anything in the cart line is a pre-order
    let buttonLabel = "Add To Cart";
    if (addMessage || addMessageSecondary) {
        buttonLabel = "Pre-Order Now";
    }

    // leave the disabled states alone, sold out and not available must win over the label swap
    if (!productFormATC.classList.contains("disabled")) {
        productFormATC.textContent = buttonLabel;
    }
    const bottomATC = document.querySelector(".productV7BottomATC");
    if (!bottomATC.classList.contains("disabled")) {
        bottomATC.textContent = buttonLabel;
    }
}

// update on load
preOrderUpdate();

/**************
 Product Quantity
 ***************/

// update quantity inputs on buttons
document.querySelector('.productV7FormQuantity').addEventListener("click", function (e) {
    const target = e.target.closest('.productV7FormQuantityButton');
    if (target) {
        let quantity = document.querySelector(".productV7FormQuantityInput").value;
        if (target.classList.contains('productV7FormQuantityButtonLess') && quantity > 1) {
            quantity--
        } else if (target.classList.contains('productV7FormQuantityButtonMore')) {
            quantity++
        }
        // update both form hidden inputs
        document.querySelector(".productV7FormQuantityInput").value = quantity;
        document.querySelector(".productV7BottomQuantityInput").value = quantity;
        // update the display
        document.querySelector(".productV7FormQuantityNumberDisplay").textContent = String(quantity);
    }
})

// update quantity on sticky bar input
document.querySelector(".productV7BottomQuantityInput")?.addEventListener("input", function () {
    document.querySelector(".productV7FormQuantityInput").value = this.value;
    document.querySelector(".productV7FormQuantityNumberDisplay").textContent = String(this.value);
});

/**************
 Product ATC
 ***************/

document.querySelector(".productV7Form").addEventListener("submit", async function (e) {
    e.preventDefault();

    document.querySelector(".productV7FormATC").classList.add("loading");

    // for "with" mode, add the ottoman first via a separate addProduct call before the main form submit
    let addedSecondary = null;
    if (secondaryProduct && ottomanMode === "with" && activeSecondaryVariant) {
        addedSecondary = await addSecondaryProduct();
    }

    const formData = new FormData(this);

    // if pre-order, update properties item
    const preOrderMessage = ottomanMode === "only" ? preOrder[activeSecondaryVariant.id]?.message : preOrder[activeVariant.id]?.message
    if (preOrderMessage) {
        formData.delete("properties");
        formData.set("properties[Pre-Order]", preOrderMessage);
    }

    // submit the main form — hidden input already holds the correct variant id for all three modes
    const addedProduct = await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', addedProduct]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    document.querySelector(".productV7FormATC").classList.remove("loading");

    // show the chair and, when added, the ottoman
    await openCart([addedProduct, addedSecondary]);
});

/**************
 Product Bottom
 ***************/

// show on scroll
let isVisible = false;
const productBottom = document.querySelector('.productV7Bottom');

// listen if the original ATC button is off the screen
window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const buttonOffsetTop = productFormATC.offsetTop;

    if (scrollTop > buttonOffsetTop && !isVisible) {
        productBottom.classList.add('active');
        isVisible = true;
    } else if (scrollTop <= buttonOffsetTop && isVisible) {
        productBottom.classList.remove('active');
        isVisible = false;
    }
})

// update active variant on input changes
document.querySelectorAll(".productV7BottomOptionItem").forEach(function (el) {
    el.addEventListener("change", function () {
        // sync top radio to match bottom select, then trigger variant update
        const topInput = document.querySelector(`.productV7OptionItemValuesLabelInput[name="${el.name}"][value="${el.value}"]`);
        if (topInput) topInput.click();
        updateBottomVariant();
    });
})

// sync bottom secondary mode select to top and update mode
if (document.querySelector(".productV7BottomSecondaryMode")) {
    document.querySelector(".productV7BottomSecondaryMode").addEventListener("change", function () {
        ottomanMode = this.value;

        // sync top radio button to match bottom
        const topModeInput = document.querySelector(`.productV7SecondaryModeValuesLabelInput[value="${ottomanMode}"]`);
        if (topModeInput) {
            topModeInput.checked = true;
        }

        preOrderUpdate()
        updateModeDisplay();
        updateBottomPrice();
    });
}

// sync bottom secondary option selects to top radio buttons
document.querySelectorAll(".productV7BottomSecondaryOptionItem").forEach(function (el) {
    el.addEventListener("change", function () {
        const optionName = this.dataset.option;
        const topInput = document.querySelector(`.productV7SecondaryOptionsItem[data-value="${optionName}"] .productV7SecondaryOptionsItemValuesLabelInput[value="${this.value}"]`);
        if (topInput) {
            topInput.checked = true;
        }

        updateSecondaryVariant();
        updateBottomPrice();
    });
});

// initial variant
let bottomVariant = activeVariant;

// currency
let bottomCurrency = document.querySelector('.productV7BottomPrice').textContent.split(" ")[1];

// update bottom bar price display
function updateBottomPrice() {
    document.querySelector(".productV7BottomPrice").textContent = price(getBottomTotalPrice()) + ` ${bottomCurrency}`;
}

// update active variant
function updateBottomVariant() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV7BottomOptionItem`).forEach(select => {
        options.push(select.value);
    });

    // find new variant based on the options
    bottomVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (bottomVariant === null || bottomVariant === undefined) {
        document.querySelector(".productV7BottomATC").classList.add("disabled");
        document.querySelector(".productV7BottomATC").textContent = "Not Available";
        return;
    }

    // update variant
    document.querySelector('.productV7BottomVariant').value = bottomVariant.id;

    // update price (factor in ottoman mode)
    updateBottomPrice();

    // check if the variant is in stock
    if (bottomVariant.available) {
        document.querySelector(".productV7BottomATC").classList.remove("disabled")
        document.querySelector(".productV7BottomATC").textContent = "Add To Cart";
    } else {
        document.querySelector(".productV7BottomATC").classList.add("disabled");
        document.querySelector(".productV7BottomATC").textContent = "Sold Out";
    }

    // the stock check above resets the label, re-apply the pre-order wording
    preOrderUpdate();
}

/**************
 Bottom ATC
 ***************/

document.querySelector(".productV7BottomRight").addEventListener("submit", async function (e) {
    e.preventDefault();

    document.querySelector(".productV7BottomATC").classList.add("loading");

    // for "with" mode, add the ottoman first via a separate addProduct call before the main form submit
    let addedSecondary = null;
    if (secondaryProduct && ottomanMode === "with" && activeSecondaryVariant) {
        addedSecondary = await addSecondaryProduct();
    }

    const formData = new FormData(this);

    // if pre-order, update properties item
    const preOrderMessage = ottomanMode === "only" ? preOrder[activeSecondaryVariant.id]?.message : preOrder[activeVariant.id]?.message
    if (preOrderMessage) {
        formData.delete("properties");
        formData.set("properties[Pre-Order]", preOrderMessage);
    }

    // submit the main form — hidden input already holds the correct variant id for all three modes
    const addedProduct = await addProduct(formData);

    document.querySelector(".productV7BottomATC").classList.remove("loading");

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', addedProduct]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // open cart with the chair and, when added, the ottoman
    await openCart([addedProduct, addedSecondary]);
});

async function addSecondaryProduct() {
    const qty = parseInt(document.querySelector(".productV7BottomQuantityInput").value);
    const formData = new FormData();
    formData.append('id', activeSecondaryVariant.id);
    formData.append('quantity', qty);
    // check pre-order status
    if (preOrder[activeSecondaryVariant.id]?.message) {
        formData.delete("properties");
        formData.set("properties[Pre-Order]", preOrder[activeSecondaryVariant.id].message);
    }
    return addProduct(formData);
}